// extracted by mini-css-extract-plugin
module.exports = {"radio":"VN","radioInput":"WN"};